<template>
    <div class="error">
        <div class="error__background"></div>
        <div class="error__container">
            <div class="error__title">
                <p>{{ title }}</p>
            </div>
            <div class="error__text">
                <p>{{ message }}</p>
            </div>
            <div class="error__button">
                <a href="#" class="button" @click.prevent="dismissError">
                    <span>OKAY</span>
                </a>
            </div>
        </div>
    </div>
</template>

<script>


    export default {
        name: 'ErrorModal',
        props: {
            title: {
                type: String,
                default: ''
            },
            message: {
                type: String,
                default: ''
            }
        },
        data() {
            return {
                documentScrollPosition: null
            }
        },
        methods: {
            dismissError() {
                this.$emit('dismissError')
            }
        },
        created() {
            this.$once('hook:destroyed', () => {
                document.body.removeAttribute('style');
                window.scrollTo(0, Math.abs(this.documentScrollPosition));
            });
        },
        mounted() {
            this.documentScrollPosition = document.body.getBoundingClientRect().y;
            document.body.setAttribute('style', `position:fixed; top:${this.documentScrollPosition}px; overflow: hidden;`);
        }
    }
</script>



// WEBPACK FOOTER //
// ErrorModal.vue?dbd2af8a